<div rds-dialog-header>
  <h2 rds-dialog-title>{{ POPUPS.FAQ.TITLE }}</h2>
</div>
<div rds-dialog-content [formGroup]="form" class="dialog-form">
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.FAQ.QUESTION_LABEL
    }}</rds-control-label>
    <input rdsInput formControlName="question" />
    @if (form.controls.question.touched && form.controls.question.errors){
    <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
    }
  </rds-form-field>
  <div class="dialog-description">
    <rds-control-label>{{ POPUPS.FAQ.ANSWER_LABEL }}
      <span class="rich-editor-field-asterisk"> * </span>
    </rds-control-label>
    <app-rich-text-editor formControlName="answer" [placeholder]="" [readonly]="false" [minHeight]="400"
      [invalid]="form.controls.answer.touched && form.controls.answer.invalid">
    </app-rich-text-editor>
    @if (
    form.controls.answer.touched && form.controls.answer.invalid
    ) {
    <div class="editor-error">
      <rds-icon namespace="outlined" icon="warning_circle"></rds-icon>
      <span>{{ ERRORS.EMPTY }}</span>
    </div>
    }
  </div>
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="false" size="m">
    {{ BUTTONS.CANCEL }}
  </button>
  <button
    rds-primary-button
    size="m"
    (click)="submit()"
    [disabled]="form.invalid"
  >
    {{ BUTTONS.ADD }}
  </button>
</div>
